<template>
  <div class="modal" v-bind:class="{ 'is-active' : show }">
    <div class="modal-background" @click="$emit('close')"></div>
    <div class="modal-card">
      <header class="modal-card-head">
        <p class="modal-card-title truncate">{{name}}</p>
        <button class="delete" aria-label="close" @click="$emit('close')"></button>
      </header>
      <section class="modal-card-body">
        <div class="content">{{description}}</div>
      </section>
    </div>
  </div>
</template>

<script>
export default {
  name: 'description-modal',
  props: {
    show: {
      type: Boolean,
      default: false,
    },
    name: {
      type: String,
    },
    description: {
      type: String,
      required: true,
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="sass" scoped>
.truncate
  text-overflow: ellipsis
  white-space: nowrap
  overflow: hidden
  flex-shrink: unset

.modal-card-body
  div
    white-space: pre-wrap
</style>



// WEBPACK FOOTER //
// src/components/DescriptionModal.vue